import Immutable from 'immutable'

import { createCoupon } from '../../records'
import { RECEIVE_SIGNUPS } from './signup/constants'

// ------------------------------------
// Constants
// ------------------------------------

// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Selectors
// ------------------------------------

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  coupons: Immutable.Set(),
})

function buildCouponsFromSignupResponse(oldCoupons, signups) {
  return signups.reduce((coupons, signup) => {
    if (!signup || !signup.coupon) {
      return coupons
    }

    return replaceCoupon(coupons, createCoupon(signup.coupon))
  }, oldCoupons)
}

function replaceCoupon(coupons, coupon) {
  return coupons
    .filter(search => coupon.id !== search.id)
    .add(coupon)
}

export default function reducer(state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case RECEIVE_SIGNUPS:
      return state.set('coupons', buildCouponsFromSignupResponse(
        state.get('coupons'),
        payload.signups,
      ))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/coupon.js